'use strict';



const uiRouter = require('angular-ui-router');

import routes from './home.routes';
import sites from '../../database/sites.json';

export class HomeComponent {
  /*@ngInject*/
  constructor(Sites, Errors, FilesUtil, $localStorage, Modal, Auth, $location, Util, $compile, $scope, $timeout) {
    'ngInject';
    let $ctrl = this;
    this.Util = Util;
    this.$compile = $compile;
    $ctrl.Sites = Sites;
    $ctrl.Errors = Errors;
    $ctrl.FilesUtil = FilesUtil;
    $ctrl.sites = [];
    $ctrl.$timeout = $timeout;
    $ctrl.$localStorage = $localStorage;
    $ctrl.Modal = Modal;
    $ctrl.Auth = Auth;
    this.$scope = $scope;
    $ctrl.$location = $location;
    this.siteIndex = 0;
    this.sites = sites;
    this.$timeout(() => {
      this.$scope.$broadcast('ts:siteReady');
    }, 500);
  }

  getSiteBySlug(slug) {
    let site = this.sites.find(site => site.slug == slug);
    this.$localStorage.site = _.cloneDeep(site);
    // this.$localStorage.site.highlight = false;
    this.$location.url(`/viewpoints/${site.viewpoints.slice(-1)[0]}`);
  }

  getSiteThumbnail(image) {
    return this.FilesUtil.getThumbnail(image);
  }

  getSiteImage(image) {
    return this.FilesUtil.getImage(image);
  }
  $onInit() {
    var $ctrl = this;


    function resizeSvgToBackgroundSize(img) {
      $('svg').height(img.height);
      $('svg').width(img.width);
    }

    var currentBackgroundSize = {
      width: null,
      height: null
    };
    var lastBackgroundSize = {
      width: null,
      height: null
    };


    function checkForSizeChanges() {
      $ctrl.$timeout(() => {
        let backgroundImage = $('img.background')[0];
        currentBackgroundSize.width = backgroundImage.clientWidth;
        currentBackgroundSize.height = backgroundImage.clientHeight;
        if(!_.isEqual(currentBackgroundSize, lastBackgroundSize)) {
          lastBackgroundSize = _.cloneDeep(currentBackgroundSize);
          checkForSizeChanges();
        } else {
          resizeSvgToBackgroundSize(currentBackgroundSize);
        }
      }, 1000);
    }
    // Hack for IE11+ with it's awful svg rendering.
    let ieVersion = this.Util.detectIE();
    if(ieVersion) {
      this.$scope.$on('ts:siteReady', () => {
        checkForSizeChanges();
      });
      $(window).on('resize', _.debounce(() => {
        lastBackgroundSize = {
          width: null,
          height: null
        };
        checkForSizeChanges();
      }, 100));
      this.$scope.$on('$destroy', () => {
        $(window).off('resize');
      });
    }

    // Check user is logged in before we trigger calibration,
    // as we don't want a flashing modal during the login state change.
    if(!$ctrl.$localStorage.hasOwnProperty('screen')) {
      $ctrl.Modal.custom.calibrationWizard();
    } else {
      $ctrl.screen = $ctrl.$localStorage.screen;
    }
  }

  videoLinkHoveredIn(id) {
    $(`#${id}`).css('stroke', 'hsl(22, 100%, 45%)');
  }

  videoLinkHoveredOut(id) {
    $(`#${id}`).css('stroke', '#4899c3');
  }

  addSite(element, id) {
    var $ctrl = this;
    element.attr('ng-click', `$ctrl.getSiteBySlug(${id})`);
    element.addClass('svg-clickable');
    // this filter/map finds all svg path elements that are slightly blue, and assigns it a class
    $('path').filter(function() {
      var fill = $(this).css('fill');
      var rgb = fill.substring(4, fill.length - 1)
          .replace(/ /g, '')
          .split(',');
      return parseInt(rgb[2], 10) > parseInt(rgb[1], 10) && parseInt(rgb[2], 10) > parseInt(rgb[0], 10);
    })
      .map(function(index, path) {
        $(path).addClass('site');
        return true;
      });
    $ctrl.$compile(element)($ctrl.$scope);
    $ctrl.$timeout(() => {
      $ctrl.$scope.$apply();
    }, 0);
  }

  addVideo(element, index) {
    var $ctrl = this;
    element.attr('ng-click', '$ctrl.openComponentModal($ctrl.site.viewpoints.videos[' + index + '])');
    element.addClass('svg-clickable pathTarget');
    $ctrl.$compile(element)($ctrl.$scope);
    $ctrl.$timeout(() => {
      $ctrl.$scope.$apply();
    }, 0);
  }

  svgOnLoad() {
    var $ctrl = this;
    var svgGroups = $(
      $('svg>g')
      .get()
      .reverse()
    );
    _.each(svgGroups, group => {
      var el = angular.element(group);
      if($(group).find('g').length > 0) {
        $ctrl.addSite(el, this.siteIndex);
        this.siteIndex++;
      }
    });
  }
  getImagePath(image) {
    return this.FilesUtil.getImage(image);
  }

  trueViewPostConstructionExample() {
    this.getSiteBySlug(5);
  }

}

export default angular.module('fplTruescapeComApp.home', [uiRouter])
  .config(routes)
  .component('home', {
    template: require('./home.html'),
    controller: HomeComponent,
    controllerAs: '$ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/home/home.component.js